import { reactive, readonly, ref, watch } from 'vue'

import featureFlagAPI from '@shared/api/featureFlag'

import { ReactivityUtil } from '@shared/utils/Reactivity'

// DATA
const initialized = ref(false)
const store = reactive({})

function featureFlagStore() {
  // METHODS
  function getFlag(key) {
    if (store[key]) {
      const _store = readonly(store)
      return _store[key]
    } else {
      return false
    }
  }

  async function install() {
    if (initialized.value) return

    try {
      ReactivityUtil.reAssign(store, await featureFlagAPI.getFeatureFlags())

      initialized.value = true
    } catch {
      //
    }
  }

  function ready() {
    return new Promise(function (resolve) {
      if (initialized.value) resolve()

      const unwatch = watch(
        () => initialized.value,
        () => {
          unwatch()
          resolve()
        }
      )
    })
  }

  return {
    getFlag,
    install,
    ready,
    flags: store
  }
}

export default featureFlagStore()
